import Config from '../constants/config';
import Helpers from '../helpers/util';

/**
 * Helper class to manage google maps api instances
 */
class GoogleMapsAPI {
	/** Private var for tracking if a request to load GMAPS has already gone out */
	static _requestedLoad = false;

	/**
	 * Loads google maps API if required - then resolves promise once loaded
	 * Else, if it's already loaded, it will resolve the promise immediately
	 */
	static load() {
		return new Promise(resolve => {
			// If we haven't asked to load already, kick off the loading process
			if (!this._requestedLoad) {
				this._requestedLoad = true;

				// Runs once google finishes loading API
				window.mapsApiIsLoaded = () => {
					window.googleMapsLoaded = true;
					Helpers.pubsub.publish('mapsApiIsLoaded');
					resolve();
				};

				// kick off loading
				const apiUrl = `https://maps.googleapis.com/maps/api/js?key=${Config.googleMapsAPIKey}&libraries=places&callback=window.mapsApiIsLoaded`;
				let js = document.createElement('script');
				js.type = 'text/javascript';
				js.async = true;
				js.src = apiUrl;
				document.body.appendChild(js);
			}
			// If we've already asked the api to laod
			else {
				// If it has finished loading already
				if (window.googleMapsLoaded) {
					resolve();
				}
				// If it hasn't finished loading yet, wait for it to laod then resolve promise
				else {
					Helpers.pubsub.subscribe('mapsApiIsLoaded', resolve);
				}
			}
		});
	}
}

export default GoogleMapsAPI;
